import * as React from 'react';
export const sageintacctSvg = React.forwardRef(function sageintacctSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.855 4c3.88 0 7.036 2.675 7.109 6.397.036 1.048-.726 1.627-1.56 1.627-.798 0-1.487-.578-1.523-1.554-.037-2.097-1.813-3.651-4.063-3.651-2.104 0-3.699 1.482-3.699 3.506 0 2.205 1.487 3.181 4.57 4.301C19.989 15.82 23 17.23 23 21.422 23 25.072 20.134 28 16.145 28 12.228 28 9 25.253 9 21.53c0-2.313 1.124-3.94 2.212-3.94.944 0 1.523.614 1.523 1.446 0 .723-.616 1.048-.616 2.35 0 2.313 1.886 3.794 4.026 3.794 2.249 0 3.736-1.554 3.736-3.433 0-2.314-1.487-3.29-4.57-4.374C11.866 16.145 9 14.663 9 10.578 9 6.893 11.974 4 15.855 4Z',
      fill: '#00D639',
    }),
  );
});
sageintacctSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sageintacct = {
  category: 'brand',
  colorable: false,
  name: 'sageintacct',
  svg: sageintacctSvg,
};
